export type WorktreeInUse = {
  path: string;
  /** Its folder's name (`ccr-2368d65e`). */
  name: string;
  /** The conversations working in it, newest first. */
  conversations: { id: string; title: string }[];
  updatedAt: string;
};

/**
 * The managed worktrees on this machine (the workspaces of `worktree` runtime whose folder is
 * there) with the active conversations working in each, the latest first.
 */
export function worktreesInUse(
  workspaces: readonly {
    rootPath: string;
    runtime: 'local' | 'worktree';
    updatedAt: string;
    availableOnDevice?: boolean;
  }[],
  conversations: readonly {
    id: string;
    title: string;
    workspaceRoot: string;
    status: 'active' | 'archived';
    updatedAt: string;
  }[],
): WorktreeInUse[] {
  return workspaces
    .filter(
      (workspace) => workspace.runtime === 'worktree' && workspace.availableOnDevice !== false,
    )
    .map((workspace) => ({
      path: workspace.rootPath,
      name: workspace.rootPath.split(/[\\/]/).filter(Boolean).at(-1) ?? workspace.rootPath,
      conversations: conversations
        .filter(
          (conversation) =>
            conversation.status === 'active' && conversation.workspaceRoot === workspace.rootPath,
        )
        .sort((left, right) => right.updatedAt.localeCompare(left.updatedAt))
        .map(({ id, title }) => ({ id, title })),
      updatedAt: workspace.updatedAt,
    }))
    .sort((left, right) => right.updatedAt.localeCompare(left.updatedAt));
}
